// for salary details of employee

export const RESER_SALARY_INFO = "resign_salary_info";
export const SALARY_INFO = "salary_info";
export const SALARY_INFO_SUCCESS = "salary_info_success";
export const SALARY_INFO_FAILURE = "salary_info_failure";
